import { render, staticRenderFns } from "./j-modal.vue?vue&type=template&id=67c0d4fc&scoped=true"
import script from "./j-modal.vue?vue&type=script&lang=js"
export * from "./j-modal.vue?vue&type=script&lang=js"
import style0 from "./j-modal.vue?vue&type=style&index=0&id=67c0d4fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c0d4fc",
  null
  
)

export default component.exports